import type { SVGProps } from 'react';

interface BookmarkIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  filled?: boolean;
}

export const BookmarkIcon = ({
  fillColor = 'currentColor',
  width = 16,
  height = 16,
  className = '',
  filled = false,
  ...props
}: BookmarkIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        d='M3 2C3 1.44772 3.44772 1 4 1H12C12.5523 1 13 1.44772 13 2V14.5C13 14.7761 12.7761 15 12.5 15C12.3828 15 12.2695 14.9578 12.18 14.8812L8 11.3333L3.82 14.8812C3.60147 15.0668 3.27646 15.0395 3.09082 14.821C3.0322 14.7516 3 14.665 3 14.5V2Z'
        fill={filled ? fillColor : 'none'}
        stroke={fillColor}
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BookmarkIcon;
